export const supportedCurrencies = ["EUR", "USD", "GBP"]

export const isCurrencySupported = currency =>
  supportedCurrencies.indexOf(currency) !== -1

export default {
  supportedCurrencies,
  isCurrencySupported,
}
